import React, { useEffect, useRef } from 'react'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

const PIN_COLORS = {
  green: '#2e7d32',
  red: '#c62828',
  blue: '#1565c0'
}

function createPinIcon(color) {
  return L.divIcon({
    className: 'demoware-checkin-marker',
    html: `<span class="fa-stack" style="position: absolute; left: -0.75rem; top: -1.5rem;">
      <span class="fa-solid fa-location-pin fa-stack-2x" style="color: ${color}; font-size: 1.8rem;"></span>
    </span>`,
    iconSize: [0, 0]
  })
}

export default function CheckInsMap({ pins }) {
  const mapRef = useRef(null)
  const mapInstanceRef = useRef(null)
  const markersRef = useRef([])

  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) return

    const map = L.map(mapRef.current)
    mapInstanceRef.current = map

    L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
    }).addTo(map)

    if (pins && pins.length > 0) {
      const bounds = []

      pins.forEach(pin => {
        if (!pin.lat || !pin.lng) return

        const color = PIN_COLORS[pin.color] || PIN_COLORS.green
        const icon = createPinIcon(color)
        const marker = L.marker([pin.lat, pin.lng], { icon })

        if (pin.name) {
          const lines = [`<strong>${pin.name}</strong>`]
          if (pin.phone) lines.push(pin.phone)
          if (pin.type) lines.push(pin.type)
          if (pin.dueDate) lines.push(`Due ${pin.dueDate}`)
          if (pin.address) lines.push(pin.address)
          if (pin.description) lines.push(pin.description)
          marker.bindPopup(lines.join('<br/>'))
        }

        marker.addTo(map)
        markersRef.current.push({ marker, pin })
        bounds.push([pin.lat, pin.lng])
      })

      if (bounds.length > 0) {
        map.fitBounds(bounds, { padding: [30, 30] })
      }
    } else {
      map.setView([40.7128, -74.006], 12)
    }

    return () => {
      map.remove()
      mapInstanceRef.current = null
      markersRef.current = []
    }
  }, [])

  useEffect(() => {
    const handleFilter = (event) => {
      const filterValue = event.detail?.filter
      const map = mapInstanceRef.current
      if (!map) return

      markersRef.current.forEach(({ marker, pin }) => {
        const isScheduled = pin.scheduled === true
        let visible = true

        if (filterValue === 'scheduled' && !isScheduled) visible = false
        if (filterValue === 'not_scheduled' && isScheduled) visible = false

        if (visible) {
          if (!map.hasLayer(marker)) marker.addTo(map)
        } else {
          if (map.hasLayer(marker)) map.removeLayer(marker)
        }
      })
    }

    document.addEventListener('checkins:filter', handleFilter)
    return () => document.removeEventListener('checkins:filter', handleFilter)
  }, [])

  return <div ref={mapRef} style={{ height: '100%', width: '100%' }} />
}
